export default __webpack_public_path__ + "static/media/subtitles-icon.c6211d4f.svg";